import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { sendData } from '../../analytics/sendData';

class SubscriptionPlan extends Component {

    componentDidMount() {
        sendData('', '', '', 'viewed', { page: 'subscription-plan' });
        window.scrollTo(0, 0);
    }

    handleSubscribe = () => {
        window.location.href = "http://m.gamiclub.com/my/my-test-gmc?offer=1";
    };

    render() {
        return (
            <section className="subscription-plan">
                <Container fluid>
                    <Row>
                        <Col xs="12">
                            <div className="subscription-title-wrap">
                                <h2 className="subscription-section-title">Subscribe to continue</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className="no-gutters">
                        <Col xs="12" className="subscription-details">
                            <p className="subscription-para">
                                Subscribe now and enjoy unlimited access to Gamiclub.
                            </p>
                            <Button color="primary" className="subscription-button" onClick={this.handleSubscribe}>
                                Subscribe - RM 8.00 per week
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }
}

export default SubscriptionPlan;



// WEBPACK FOOTER //
// ./src/components/StaticPages/SubscriptionPageMaxis.js